import { render, staticRenderFns } from "./SharingChatGPTHistory.vue?vue&type=template&id=74cb7b68&scoped=true&"
import script from "./SharingChatGPTHistory.vue?vue&type=script&lang=js&"
export * from "./SharingChatGPTHistory.vue?vue&type=script&lang=js&"
import style0 from "./SharingChatGPTHistory.vue?vue&type=style&index=0&id=74cb7b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cb7b68",
  null
  
)

export default component.exports